module.exports = "<h1><ng-content select=\"header\"></ng-content></h1>\n<div *ngIf=\"isOpen\">\n  <ng-content select=\"content\"></ng-content>>\n  <button (click)=\"rollUp()\">Close</button>\n</div>\n\n<ng-content select=\"footer\"></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/rolldown/rolldown/rolldown.component.html
// module id = ../../../../../src/app/shared/rolldown/rolldown/rolldown.component.html
// module chunks = main